import axios from "axios";

const baseUrl = process.env.VUE_APP_API_URL;

const httpClient = axios.create({
  baseURL: baseUrl,
});

export default httpClient;
